module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/persional-seperation-0.5f801357.png";